import jQuery from 'jquery';
import select2 from 'select2';
import scrollHandler from "./scrollHandler";
import pageRegisterWarranty from "./page-register-warranty";
import pageSummary from "./page-summary";
import pageHomepage from "./page-homepage";
import {Modal} from "bootstrap";
import pageConfirmation from "./page-confirmation";
import {checkIphone, checkIpad} from "./checkDevices";
import analyticsEventPusher from "../../../elica/assets/js/analytics-event-pusher";
import Core from "./core";

select2();

window.$ = window.jQuery = jQuery;

(function ($) {
    Core.token();
    analyticsEventPusher();
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    scrollHandler();

    /**
     * Force page to load on top
     */
    if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
    } else {
        window.onbeforeunload = function () {
            window.scroll(0, 0);
        }
    }

    var oldSelect2 = jQuery.fn.select2;
    jQuery.fn.select2 = function () {
        if (arguments.length === 1 && typeof arguments[0] === 'object' && typeof arguments[0].dropdownParent !== 'defined') {
            const modalParent = jQuery(this).parents('div.modal').first();
            if (modalParent.length > 0) {
                arguments[0].dropdownParent = modalParent;
            }
        }
        return oldSelect2.apply(this, arguments);
    };

    pageHomepage();
    pageRegisterWarranty();
    pageSummary();
    pageConfirmation();

    setInterval(function () {
        $.ajax({
            url: refreshCSRF,
            method: 'get'
        }).then(function (response) {
            $('meta[name="csrf-token"]').attr('content', response);
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': response
                }
            });
        });
    }, 1000 * 60);

    /**
     * iOs iPadOS input future dates alert
     */
    if (checkIphone || checkIpad) {
        $('body').on('change', '.input-date', function () {
            const today = new Date().toISOString().slice(0, 10);
            if ($(this).val() > today) {
                const noFutureDate = $(this).next('.no-future-date').text();
                if (typeof "undefined" !== noFutureDate) {
                    alert(noFutureDate);
                    this.value = today; // set current date
                    this.blur(); // remove focus
                }
            }
        });
    }
})(jQuery);
